import React from 'react';
import {
  TableBody,
  TableHead,
  TableRow
} from '@mui/material';
import PreloaderComponent from '#component/preloader';
import NotFoundMessage from '#component/general/not-found-message';
import {
  CheckboxTableCell,
  RootProjectTableCell,
  RowTableCell,
  StyledPaper,
  StyledPersonIcon,
  StyledTable,
  StyledTableCell,
  StyledTableCheckBox,
  StyledTableRow,
  TableCheckbox,
  TitleCellCnt,
  UsersTableCell
} from './styles';

const TableView = ({
  data,
  loading,
  selected,
  setSelected,
  showModeOnly
}) => {
  const isSelected = (id, selectedData) => selectedData.map(s => s.id).indexOf(id) !== -1;

  const handleClick = (event, device) => {
    if (event.target.getAttribute('data-checkbox')) return;

    const selectedIndex = selected.map(s => s.id).indexOf(device.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, device);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      setSelected(data);
      return;
    }
    setSelected([]);
  };

  if (!data?.length && loading) {
    return <PreloaderComponent />;
  }

  if (!data?.length && !loading) {
    return (
      <NotFoundMessage>
        No users
      </NotFoundMessage>
    );
  }

  return (
    <StyledPaper>
      <StyledTable loading={loading} size="small">
        <TableHead>
          <TableRow hover={false}>
            {!showModeOnly &&
            <StyledTableCell padding="checkbox">
              <StyledTableCheckBox
                color="primary"
                checked={(data.length > 0 && selected.length > 0) &&
                  selected.length === data.length}
                indeterminate={selected.length > 0 && selected.length !== data.length}
                onChange={handleSelectAllClick}
                inputProps={{
                  'aria-label': 'select all'
                }}
              />
            </StyledTableCell>}
            <UsersTableCell id="users" title="Users" withoutHover={showModeOnly}>
              Users
            </UsersTableCell>
            <RootProjectTableCell
              id="root-project"
              title="Root project"
              withoutHover={showModeOnly}
            >
              Root project
            </RootProjectTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map(d => {
            const isItemSelected = isSelected(d.id, selected);
            const isDisabledUser = Boolean(d.disabled);
            const rootProject = d.project ? (
              d.project.map((project, index) => (
                <React.Fragment key={index}>
                  {project.title}
                  {index !== d.project.length - 1 ? ', ' : ''}
                  <br />
                </React.Fragment>
              ))
            ) : null;
            return (
              <StyledTableRow
                key={d.id}
                hover={!loading}
                withoutHover={showModeOnly}
                onClick={!showModeOnly ? event => handleClick(event, d) : null}
                selected={isItemSelected}
              >
                {!showModeOnly &&
                  <CheckboxTableCell padding="checkbox">
                    <TableCheckbox
                      color="secondary"
                      checked={isItemSelected}
                      inputProps={{
                        'aria-labelledby': d.id
                      }}
                    />
                  </CheckboxTableCell>}
                <RowTableCell
                  scope="row"
                  component="th"
                  style={{ whiteSpace: 'nowrap' }}
                  withoutHover={showModeOnly}
                >
                  <TitleCellCnt>
                    <StyledPersonIcon disableduser={isDisabledUser} />
                    {`${d.firstName} ${d.lastName}`}
                  </TitleCellCnt>
                </RowTableCell>
                <RowTableCell
                  align="left"
                  withoutHover={showModeOnly}
                >
                  {rootProject}
                </RowTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </StyledTable>
    </StyledPaper>
  );
};

export default TableView;
